import { useGtm } from '@gtm-support/vue-gtm';


export function useAnalytics() {
    const gtm = useGtm();

  function sendEvent(eventName: string, options: any = {}) {
    if (!gtm) {
      // eslint-disable-next-line no-console
      console.warn('GTM not available, event not sent:', eventName);
      return;
    }

    gtm.trackEvent({ event: eventName, ...options});
  }

  return { sendEvent };
} 